// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#hoursList[data-v-49f465ba]{position:relative}@media screen and (min-width:992px){#hoursList[data-v-49f465ba]{height:420px;overflow-y:auto}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
